<template>
  <div class="app-main-inner">
    <div class="app-main-inner-row">
      <div class="filters">
        <el-form :inline="true" :label-width="isZh ? '80px' : '125px'" label-position="left">
          <div class="el-form-item-wrapper">
            <el-form-item :label="labelName">
              <!--起运港/目的港 (海运)-->
              <cargo-advance-select
                v-if="(criteriaType === 3 || criteriaType === 4) && ( seaLobArray.includes(lob) )"
                no="Seaport"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_Seaport"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                :default-value="criteriaValue"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--起运港/目的港 (空运)-->
              <cargo-advance-select
                v-if="(criteriaType === 3 || criteriaType === 4) && (airLobArray.includes(lob))"
                no="Airport"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_Airport"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                :default-value="criteriaValue"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--起运港/目的港 (铁路)-->
              <cargo-advance-select
                v-if="(criteriaType === 3 || criteriaType === 4) && (railLobArray.includes(lob))"
                no="RailwayStation"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_RailwayStation"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                :clear-not-match="true"
                :default-value="criteriaValue"
                style="width: 100%"
                @parentCallBack="getValueFromChild"
              />
              <!--海外仓-->
              <cargo-advance-select
                v-if="criteriaType === 12"
                no="OverseaWarehouse"
                filterable
                :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="value"
                style="width: 100%"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!--用户-->
              <cargo-advance-select
                v-if="criteriaType === 6"
                no="User"
                :disabled="locked"
                filterable
                :select-type="selectTypeNames.basic_data_User"
                :callback-params="{key:'criteriaValue'}"
                callback-method-type="obj"
                :default-value="criteriaValue"
                style="width:205px;"
                tag-name="chineseName"
                :fields="['chineseName']"
                options-width="250px"
                @parentCallBack="getValueFromChild"
              />
              <!--可用分公司-->
              <cargo-advance-select
                v-if="criteriaType === 13"
                no="Office"
                :disabled="locked"
                filterable
                style="width:205px;"
                :select-type="selectTypeNames.basic_data_Office"
                :callback-params="{key:'criteriaValue'}"
                :default-value="criteriaValue"
                :method-params="{}"
                :custom-label="(item)=>`[${item.code}]${isZh ? item.chineseName : item.englishName}`"
                :filter-tag-names="['code', isZh ? 'chineseName' : 'englishName']"
                :show-custom-label-in-option="true"
                @parentCallBack="getValueFromChild"
              />
              <!--HS Code-->
              <el-input
                v-if="criteriaType === 5"
                v-model="criteriaValue"
                v-uppercase
                no="HSCode"
                :disabled="locked"
                style="width: 286px;"
              />
              <!-- 委托单位-->
              <cargo-advance-select
                v-if="criteriaType === 7"
                no="Customer"
                filterable
                style="width:205px;"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{customer:true, active: true}"
                callback-method-type="value"
                :default-value="criteriaValue"
                :callback-params="{key:'customerId'}"
                @parentCallBack="getValueFromChild"
              />
              <!--承运人-->
              <cargo-advance-select
                v-if="criteriaType === 8"
                no="SeaCmp"
                filterable
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{seaCmp:true, active: true}"
                :custom-label="(item)=>`${item.chineseName}`"
                :show-custom-label-in-option="true"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!-- 订舱代理-->
              <cargo-advance-select
                v-if="criteriaType === 9"
                no="BookingAgent"
                filterable
                options-width="250px"
                :method-params="{bookingAgent:true, active: true}"
                :select-type="selectTypeNames.basic_data_Company"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!-- 航线/区域-->
              <cargo-advance-select
                v-if="criteriaType === 10"
                no="Region"
                filterable
                :select-type="selectTypeNames.basic_data_Region"
                :callback-params="{key:'region'}"
                callback-method-type="value"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!-- 目的港代理-->
              <cargo-advance-select
                v-if="criteriaType === 11"
                no="OverseaAgent"
                filterable
                tag-name="englishName"
                options-width="250px"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true, active: true}"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!-- 换单代理-->
              <cargo-advance-select
                v-if="criteriaType === 14"
                no="ExchangeAgent"
                filterable
                options-width="250px"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true, active: true}"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
              <!-- 指定货代理-->
              <cargo-advance-select
                v-if="criteriaType === 15"
                no="DesignationAgent"
                filterable
                options-width="250px"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{designationAgent:true, active: true}"
                style="width: 205px"
                :default-value="criteriaValue"
                @parentCallBack="getValueFromChild"
              />
            </el-form-item>
            <el-form-item>
              <el-button no="Add" :disabled="locked" type="primary" @click="add">{{ $t('CargoMsg.Cargo_add') }}</el-button>
              <el-button no="Delete" :disabled="locked" type="danger" @click="remove">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
            </el-form-item>
            <span v-if="criteriaType === 6" style="color: red;padding-left: 8px;">{{ $t('CargoMsg.Cargo_SchemeUserTips') }}</span>
          </div>
        </el-form>
      </div>
    </div>
    <div class="app-main-inner-row row-grid" style="min-height: 400px;">
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        style="width: 100%;"
      />
    </div>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import lodash from 'lodash'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  /**
   * 费用方案维护弹窗中除费用明细外的四个tab维护的内容是一致的，应整合为一个组件
   * PolGroup
   * PodGroup
   * UserGroup
   * HsCodeGroup
   */
  name: 'GroupTab',
  components: { cargoAdvanceSelect },
  props: {
    groupName: { type: String, required: true }, // 起运港:'POL' , 目的港:'POD' , HSCODE:'HSCODE' , 用户:'USER'
    status: { type: String, required: true },
    detailValue: { type: Array, default: null },
    locked: { type: Boolean, default: false },
    isNeedChangePort: { type: Boolean, default: false },
    lob: { type: String, default: '' }
  },
  data() {
    return {
      seaPortList: [],
      selectTypeNames: TYPE_NAMES,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true,
          suppressMenu: true
        },
        pagination: false
      },
      rowData: [],
      originRowData: [],
      // 起运港ChargeSchemeConstants.CRITERIA_POL
      polColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_PortOfLoading'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return this.portCellRenderHandler(params.value)
          }
        }
      ],
      // 目的港
      podColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return this.portCellRenderHandler(params.value)
          }
        }
      ],
      // 用户
      userColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_User'),
          field: 'criteriaValue',
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }
      ],
      // 可用分公司
      branchColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AvailableBranch'),
          field: 'criteriaValue',
          cellRenderer: params => {
            const officeArr = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Office_All, (item) => item.officeId === Number(params.value))
            return officeArr && officeArr.length > 0 ? `[${officeArr[0].code}]${this.isZh ? officeArr[0].chineseName : officeArr[0].englishName}` : ''
          }
        }
      ],
      // HS Code
      hsCodeColumnDefs: [
        {
          headerName: 'Hs Code',
          field: 'criteriaValue'
        }
      ],

      // 委托单位
      customerColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_AuthorizedClient'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      // 承运人
      carrierColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_Carrier'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      // 订舱代理
      bookingAgentColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_BookingAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      // 航线/区域
      sAColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_ShippingRouteArea'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Region, 'code', params.value, 'name')
          }
        }
      ],
      // 目的港代理
      destinationAgentColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'englishName')
          }
        }
      ],
      // 海外仓
      overseaWarehouseColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_OverseaWarehouse'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_OverseaWarehouse, 'warehouseCode', params.value, 'warehouseCode')
          }
        }
      ],
      exchangeAgentColumnDefs: [
        {
          headerName: this.$t('SeaExport.BillExchangeAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      designationAgentColumnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_NominatedAgent'),
          field: 'criteriaValue',
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
          }
        }
      ],
      criteriaValue: '',
      seaLobArray: ['', 'IE', 'SE', 'SI', 'FBA_SE'],
      airLobArray: ['AE', 'AI', 'FBA_AE'],
      railLobArray: ['RE', 'RI', 'FBA_RE']
    }
  },
  computed: {
    isZh() {
      return this.$i18n.locale === 'zh'
    },
    columnDefs() {
      switch (this.groupName) {
        case 'POL':
          return this.polColumnDefs
        case 'POD':
          return this.podColumnDefs
        case 'USER':
          return this.userColumnDefs
        case 'BRANCH':
          return this.branchColumnDefs
        case 'HSCODE':
          return this.hsCodeColumnDefs
        case 'CUSTOMER':
          return this.customerColumnDefs
        case 'CARRIER':
          return this.carrierColumnDefs
        case 'BOOKING-AGENT':
          return this.bookingAgentColumnDefs
        case 'SA':
          return this.sAColumnDefs
        case 'DESTINATION-AGENT':
          return this.destinationAgentColumnDefs
        case 'OVERSEA-WAREHOUSE':
          return this.overseaWarehouseColumnDefs
        case 'EXCHANGE-AGENT':
          return this.exchangeAgentColumnDefs
        case 'DESIGNATION-AGENT':
          return this.designationAgentColumnDefs
        default:
          return []
      }
    },
    labelName() {
      switch (this.groupName) {
        case 'POL':
          return this.$t('CargoMsg.Cargo_PortOfLoading')
        case 'POD':
          return this.$t('CargoMsg.Cargo_DestinationPort')
        case 'USER':
          return this.$t('CargoMsg.Cargo_User')
        case 'BRANCH':
          return this.$t('CargoMsg.Cargo_AvailableBranch')
        case 'HSCODE':
          return 'HS Code'
        case 'CUSTOMER':
          return this.$t('CargoMsg.Cargo_AuthorizedClient')
        case 'CARRIER':
          return this.$t('CargoMsg.Cargo_Carrier')
        case 'BOOKING-AGENT':
          return this.$t('CargoMsg.Cargo_BookingAgent')
        case 'SA':
          return this.$t('CargoMsg.Cargo_ShippingRouteArea')
        case 'DESTINATION-AGENT':
          return this.$t('CargoMsg.Cargo_DestinationAgent')
        case 'OVERSEA-WAREHOUSE':
          return this.$t('CargoMsg.Cargo_OverseaWarehouse')
        case 'EXCHANGE-AGENT':
          return this.$t('SeaExport.BillExchangeAgent')
        case 'DESIGNATION-AGENT':
          return this.$t('CargoMsg.Cargo_NominatedAgent')
        default:
          return ''
      }
    },
    criteriaType() {
      // 1, 整拼类型 Container Load Type  2, 部门 Department 3,起运港 POL 4, 目的港 , POD  5, HS CODE ,  HSCODE  6,用户
      switch (this.groupName) {
        case 'POL':
          return 3
        case 'POD':
          return 4
        case 'USER':
          return 6
        case 'HSCODE':
          return 5
        case 'CUSTOMER':
          return 7
        case 'CARRIER':
          return 8
        case 'BOOKING-AGENT':
          return 9
        case 'SA':
          return 10
        case 'DESTINATION-AGENT':
          return 11
        case 'OVERSEA-WAREHOUSE':
          return 12
        case 'BRANCH':
          return 13
        case 'EXCHANGE-AGENT':
          return 14
        case 'DESIGNATION-AGENT':
          return 15
        default:
          return 0
      }
    }
  },
  watch: {
    async status(val) {
      this.created()
    },
    isNeedChangePort(val) {
      if (val && (this.criteriaType === 3 || this.criteriaType === 4)) {
        this.rowData = []
      }
    }
  },
  async created() {
    if (['edit', 'copy'].includes(this.status) || (this.status === 'add' && this.criteriaType === 13)) {
      this.rowData = this.detailValue
    }
    this.originRowData = this.status === 'copy' ? [] : lodash.cloneDeep(this.rowData)
  },
  methods: {
    getValueFromChild(obj) {
      this.criteriaValue = obj.value ? obj.value : ''
    },
    add() {
      if (!this.criteriaValue) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.labelName)
        return
      }
      const self = this
      const existsRows = this.rowData.filter(row => {
        return String(row.criteriaValue) === String(self.criteriaValue)
      })
      if (existsRows.length > 0) {
        this.$message.error(self.$t('common.tips.repeatedlyTip'))
      } else {
        this.rowData.push({ criteriaValue: this.criteriaValue })
        this.notifyParent()
      }
      this.criteriaValue = ''
    },
    remove() {
      if (this.rowData.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = cell ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (selectedRow) {
        if (this.criteriaType === 13 && Number(selectedRow.criteriaValue) === this.$store.getters.currentOfficeId) {
          this.$message.error(this.$t('common.tips.cannotDeleteBranch'))
          return
        }
        const index = this.rowData.findIndex(row => row.criteriaValue === selectedRow.criteriaValue)
        if (index > -1) {
          this.rowData.splice(index, 1)
          this.gridOptions.api.refreshCells({ force: true })
          this.notifyParent()
        }
        this.gridOptions.api.clearFocusedCell()
      } else {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
      }
    },
    // 筛选出新增&和删除项并返还给父组件
    notifyParent() {
      let addRow = []
      if (this.rowData && this.rowData.length > 0) {
        if (this.originRowData && this.originRowData.length > 0) {
          // 原列表没有，但rowData中有的数据，视为新增
          this.rowData.forEach(row => {
            const newRow = this.originRowData.find(originRow => originRow.criteriaValue === row.criteriaValue)
            if (!newRow) {
              addRow.push(row)
            }
          })
        } else {
          addRow = [...this.rowData]
        }
      }
      let delRow = []
      if (this.originRowData && this.originRowData.length > 0) {
        if (this.rowData && this.rowData.length > 0) {
          delRow = this.originRowData.filter(originRow => {
            const rows = this.rowData.filter(row => {
              return originRow.criteriaValue === row.criteriaValue
            })
            return rows.length < 1
          })
        } else {
          delRow = this.originRowData
        }
      }
      const rows = []
      addRow.forEach(row => {
        rows.push({
          criteriaType: this.criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'add'
        })
      })
      delRow.forEach(row => {
        rows.push({
          uuid: row.uuid,
          criteriaType: this.criteriaType,
          criteriaValue: row.criteriaValue,
          waitDealStatus: 'delete'
        })
      })
      this.$emit('func', rows)
    },
    portCellRenderHandler(value) {
      let result = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Seaport, 'code', value, 'englishName')
      if (!result) {
        result = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_Airport, 'code', value, 'englishName')
      }
      if (!result) {
        result = ColumnUtils.resolveColumnLabel(this.selectTypeNames.basic_data_RailwayStation, 'code', value, 'chineseName')
      }
      return result || ''
    }
  }
}
</script>
